const state = {
  myPanelRole: null,
  // Set once a DOD call returns 403 DOD_ACCESS_REVOKED. Only disables the DOD
  // module - the user keeps their main SeniorApp admin session (this is a shared
  // panel, so a full logout would lock them out of everything).
  dodAccessRevoked: false,
  settlementCounters: null,
};
const mutations = {
  SET_MY_PANEL_ROLE(state, role) {
    state.myPanelRole = role;
  },
  SET_DOD_ACCESS_REVOKED(state, val) {
    state.dodAccessRevoked = val;
  },
  SET_SETTLEMENT_COUNTERS(state, counters) {
    state.settlementCounters = counters;
  },
};
const getters = {
  getMyPanelRole: (state) => state.myPanelRole,
  getIsSettlementAdmin: (state) => state.myPanelRole === "ADMINISTRATOR",
  getDodAccessRevoked: (state) => state.dodAccessRevoked,
  getSettlementCounters: (state) => state.settlementCounters,
};

export default {
  state,
  mutations,
  getters,
};
